<template lang="pug">
  .b-project-member-add-popup
    BasePopup(v-if="isOpened" @close="close")
      ._result(v-if="added") Пользователь добавлен
      ._container(v-else)
        ._invite-title Пригласить в проект
        BaseSelect._project-select(:options="projectsSelectOptions" v-model="project" label="Проекты" :error="error")
        UserTile(:user="user")
        Btn(sm @click="add" :disabled="!project || userIsAlreadyAdded" :title="btnTitle") Пригласить
        ._error._already-added(v-if="userIsAlreadyAdded") Этот пользователь уже является участником выбранного проекта
        ._error(v-if="error") {{ error }}
</template>

<script>
import projectMemberApi from '@/api/projectMember';

import BaseSelect from '@/components/BaseSelect.vue';
import BasePopup from '@/components/BasePopup.vue';
import UserTile from '@/components/UserTile.vue';

export default {
  name: 'ProjectMemberAddPopup',
  components: { BaseSelect, UserTile, BasePopup },
  controller: null,
  props: {
    projects: Array,
    members: Object,
  },
  data() {
    return {
      isOpened: false,
      user: null,
      project: null,
      added: false,
      error: '',
    };
  },
  computed: {
    userIsAlreadyAdded() {
      const membersOfProject = this.members[this.project] ?? [];
      return membersOfProject.includes(this.user.id);
    },
    projectsSelectOptions() {
      return this.projects
        .filter((p) => !p.isArchived)
        .map((p) => ({
          value: p.id,
          label: p.name,
        }));
    },
    btnTitle() {
      if (!this.project) return 'Выберите проект';
      if (this.userIsAlreadyAdded) return 'Зтот пользователь уже является участником проекта';
      return '';
    },
  },
  methods: {
    open(user) {
      this.user = user;
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      this.added = false;
      this.$options.controller.resolve(false);
    },
    add() {
      this.error = '';
      const project = this.projects.find((p) => p.id === this.project);
      projectMemberApi.create({
        project: project['@id'],
        user: this.user['@id'],
        role: 'standard',
      })
        .then(() => {
          this.added = true;
        })
        .catch((e) => {
          if (e['hydra:description'] === 'user: This member already exists') {
            this.error = 'Этот пользователь уже является участником выбранного проекта';
          } else {
            this.error = 'Неизвестная ошибка';
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.project-member-add-popup {
  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: center;
  }

  &__project-select {
    grid-column: 1 / 2 span;
  }

  &__error {
    grid-column: 1 / 2 span;
    color: red;
  }
}
</style>
